import {Component, Inject, OnInit} from '@angular/core';
import {FileSaverService} from 'ngx-filesaver';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
@AcDialog({
  id: 'certificateViewId',
  width: 700,
})
@Component({
  selector: 'certificate-view',
  templateUrl: './certificate-view.component.html',
  styleUrls: ['./certificate-view.component.scss']
})
export class CertificateViewComponent implements OnInit {

  certificates = [];

  constructor(private fileSaver: FileSaverService,
              @Inject(DIALOG_CONFIG) public dialogConfig) {
    this.certificates = dialogConfig.dialogData;
  }

  ngOnInit(): void {
  }

  downloadPem(certificate: any): void {
    const fileType = {type: 'text/plain'};
    const blob = new Blob([certificate.pem], fileType);

    this.fileSaver.save(blob, `${certificate.alias || 'certificate'}.cer`);
  }



}
